module.exports = __webpack_public_path__ + "media/images/flags/BR-0075e2fe6a0ff0513d881203df965df0.svg";